import { create } from 'zustand';

const MENU_LABEL_STORAGE_KEY = 'menu_labels';

type LabelByKey = Record<string, string>;

interface MenuLabelState {
  labels: LabelByKey;
  setLabels: (labels: LabelByKey) => void;
}

function loadPersistedLabels(): LabelByKey {
  try {
    const stored = localStorage.getItem(MENU_LABEL_STORAGE_KEY);
    if (!stored) return {};
    return JSON.parse(stored) as LabelByKey;
  } catch {
    return {};
  }
}

function persistLabels(labels: LabelByKey) {
  try {
    localStorage.setItem(MENU_LABEL_STORAGE_KEY, JSON.stringify(labels));
  } catch {
    return;
  }
}

function isSameLabels(left: LabelByKey, right: LabelByKey): boolean {
  const keys = Object.keys(left);
  return keys.length === Object.keys(right).length && keys.every((key) => left[key] === right[key]);
}

export const useMenuLabelStore = create<MenuLabelState>((set) => ({
  labels: loadPersistedLabels(),
  setLabels: (labels) =>
    set((state) => {
      if (isSameLabels(state.labels, labels)) return state;
      persistLabels(labels);
      return { labels };
    }),
}));
